<span class="d-inline-flex align-items-center gap-1 flex-wrap">
  @if (style; as s) {
    <span class="w-max inline-flex items-center gap-1 py-0.5 px-3 rounded-4xl text-[13px] border {{ s.classes }}">
      <i-tabler class="icon-14" [name]="s.icon" />
      {{ s.label | translate }}
    </span>
  }
  @if (showCancelled) {
    <span class="w-max inline-flex items-center gap-1 py-0.5 px-3 rounded-4xl text-[13px] border {{ cancelledStyle.classes }}">
      <i-tabler class="icon-14" [name]="cancelledStyle.icon" />
      {{ cancelledStyle.label | translate }}
    </span>
  }
</span>
